import styled from 'styled-components';

import { colors, fontSizes, fontWeights } from '../../theme';

export const Container = styled.label`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Label = styled.span<{ $hasError: boolean }>`
  margin: 0 0 12px 12px;
  color: ${({ $hasError }) => ($hasError ? colors.error : colors.navy)};
  font-weight: ${fontWeights.medium};
  font-size: ${fontSizes.m};
  line-height: 18px;
  text-align: left;
  user-select: none;
`;

export const TextareaElement = styled.textarea<{ $hasError: boolean }>`
  width: 100%;
  padding: 16px;
  overflow: hidden;
  color: ${colors.navy};
  font-weight: ${fontWeights.regular};
  font-size: ${fontSizes.m};
  background: ${({ disabled }) => (disabled ? colors.sand : colors.white)};
  border: 1px solid
    ${({ $hasError }) => ($hasError ? colors.error : colors.concrete)};
  border-radius: 12px;
  cursor: ${({ disabled }) => disabled && 'not-allowed'};
  caret-color: ${colors.navy};
  resize: none;
  pointer-events: auto;

  &::placeholder {
    color: ${colors.pigeon};
  }

  &:hover {
    border-color: ${colors.mouse};
  }

  &:focus {
    border-color: ${({ $hasError }) =>
      $hasError ? colors.error : colors.ocean};
    box-shadow: 0 0 1px 2px ${colors.sky};
  }
`;

export const CharacterCount = styled.span.attrs({
  role: 'status',
})`
  margin-top: 8px;
  padding: 0 8px;
  color: ${colors.pigeon};
  font-weight: ${fontWeights.regular};
  font-size: ${fontSizes.xs};
  text-align: right;
`;
